"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFocusedExplicitly;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useFocusedExplicitly() {
  return (0, _useContext.default)().focusedExplicitlyState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VGb2N1c2VkRXhwbGljaXRseSIsInVzZVRyYW5zY3JpcHRGb2N1c0NvbnRleHQiLCJmb2N1c2VkRXhwbGljaXRseVN0YXRlIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcHJvdmlkZXJzL1RyYW5zY3JpcHRGb2N1cy91c2VGb2N1c2VkRXhwbGljaXRseS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlVHJhbnNjcmlwdEZvY3VzQ29udGV4dCBmcm9tICcuL3ByaXZhdGUvdXNlQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUZvY3VzZWRFeHBsaWNpdGx5KCk6IHJlYWRvbmx5IFtib29sZWFuXSB7XG4gIHJldHVybiB1c2VUcmFuc2NyaXB0Rm9jdXNDb250ZXh0KCkuZm9jdXNlZEV4cGxpY2l0bHlTdGF0ZTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRWUsU0FBU0Esb0JBQVQsR0FBb0Q7RUFDakUsT0FBTyxJQUFBQyxtQkFBQSxJQUE0QkMsc0JBQW5DO0FBQ0QifQ==